import { SettingType, SystemConfigKey } from 'src/type/settings';

export const findLatestUpdated = (data: SettingType[]) => {
  if (data.length === 0) {
    return '';
  }

  const keys = [
    SystemConfigKey.SUNDAY,
    SystemConfigKey.MONDAY,
    SystemConfigKey.TUESDAY,
    SystemConfigKey.WEDNESDAY,
    SystemConfigKey.THURSDAY,
    SystemConfigKey.FRIDAY,
    SystemConfigKey.SATURDAY,
    SystemConfigKey.WEEKLY_START_TIME,
    SystemConfigKey.WEEKLY_END_TIME,
  ];

  const filteredData = data.filter((item) => keys.includes(item.key));

  const setting = filteredData.reduce(
    (latest, item) => {
      if (!latest || new Date(item.updatedAt) > new Date(latest.updatedAt)) {
        return item;
      }
      return latest;
    },
    undefined as SettingType | undefined
  );

  // return result;

  if (!setting?.approvedByUser) {
    return null;
  }

  return { user: setting.approvedByUser, updatedAt: setting.updatedAt };
};
